import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import "@/i18n";
import { initAnalytics } from "@/lib/platform/analytics";
import { initErrorReporting } from "@/lib/platform/errors";
import { env } from "@/lib/platform/env";
import "@fontsource/onest/600.css";
import "@/styles.css";

void initErrorReporting();
initAnalytics();

// Offline start for the installed app. Not in development: a cached shell hides fresh changes.
if (env.mode === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
